import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { TreatmentCategory } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<TreatmentCategory.Basic>> =>
	Http.get(baseUrl, { params })
